import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';

import { callApi, formatDateTime } from '../../utils';

import Loading from '../Loading';
import DataTable from '../DataTable';

function FraudEvents(props) {
  const { user } = props;

  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    setLoading(true);
    callApi(`/users/${user.id}/fraud-events`)
      .then(({ data = [] }) => {
        if (!data || !data.length) {
          return [];
        }

        setRows(data);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <React.Fragment>
      <Row>
        <Col>
          <DataTable card={false} loading={loading} minWidth={700}>
            <thead>
              <tr>
                <th>Event</th>
                <th>Notes</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((fraudEvent) => (
                <tr key={fraudEvent.id}>
                  <td>{fraudEvent.type}</td>
                  <td>{fraudEvent.notes}</td>
                  <td>{fraudEvent.status}</td>
                  <td>{formatDateTime(fraudEvent.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </DataTable>
        </Col>
      </Row>
    </React.Fragment>
  );
}

export default connect()(FraudEvents);
